import styles from './Cart.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyCartPage } from 'src/components/Cart/EmptyCartPage/EmptyCartPage';
import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { OrderSummary } from 'src/components/OrderSummary/OrderSummary';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useDesktop, useDesktopLarge, useMobile } from 'src/hooks/UseResponsive';
import { CartLineItem } from '../CartLineItem/CartLineItem';

import { useHistory } from 'react-router-dom';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import { CheckoutRoutePath } from '../Checkout/Checkout';
import { CheckoutProvider } from '../Checkout/CheckoutProvider';
import { MoreAccessories } from './MoreAccessories/MoreAccessories';
import { useCart } from './UseCart';

export const Cart: React.FC = () => {
  const history = useHistory();
  const isMobile = useMobile();
  const isDesktop = useDesktop();
  const isDesktopLarge = useDesktopLarge();
  const { cart, isLoading } = useCart();
  const { t } = useTranslation();

  const continueButtonClickHandler = () => {
    history.push(redesignV2RoutePath.CHECKOUT + CheckoutRoutePath.INFO);
  };

  return (
    <CheckoutProvider>
      <section className={styles.cart}>
        {cart?.bundle ? (
          <GridContainer gutter justifyContent="center" direction={isMobile ? 'column-reverse' : 'row'}>
            {isDesktopLarge && <Grid item xs />}
            <Grid item xs={12} md={8} lg={7} xl={6}>
              <CartLineItem cartData={cart} />
              <MoreAccessories />
            </Grid>
            {(isDesktop || isDesktopLarge) && <Grid item xs />}
            <Grid item xs={12} md={4} xl={3}>
              <OrderSummary
                continueButtonClickHandler={continueButtonClickHandler}
                backButtonVisible={false}
              />
            </Grid>
          </GridContainer>
        ) : isLoading ? (
          <TextV2 value={t('cart-page.loading')} />
        ) : (
          <EmptyCartPage />
        )}
      </section>
    </CheckoutProvider>
  );
};

Cart.displayName = 'Cart';
